import { platformApiUnauth } from "@/api/http";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
}

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await platformApiUnauth.post<LoginResponse>(
      "/api/v1/auth/login/staff",
      credentials,
    );
    return response.data;
  },

  // Always returns a generic success message (no account enumeration).
  forgotPassword: async (email: string): Promise<void> => {
    await platformApiUnauth.post("/public/auth/forgot-password", { email });
  },
};
